// Consultation/NearestConsultationWidget.tsx
import React, {useMemo} from 'react';
import {FR, FRCC, FRSC} from 'WideLayout/Layouts';
import Button from "Core/components/elements/Button/Button";
import {useNavigate} from "react-router-dom";
import {useTheme} from "Theme/ThemeContext";
import {Message} from "Core/components/Message";
import {IConsultation} from "Types/psychology/consultation";

interface NearestConsultationWidgetProps {
    nextConsultation: IConsultation | null;
}

const NearestConsultationWidget: React.FC<NearestConsultationWidgetProps> = ({nextConsultation}) => {
    const navigate = useNavigate();
    const {plt, theme} = useTheme();
    const handleJoinConference = () => {

        if (nextConsultation?.conference && nextConsultation.conference.name) {
            navigate(`/conference/${nextConsultation.id}`);
        } else {
            Message.error('Комната не найдена');
        }
    };
    const nextConsultationTime = useMemo(() => {
        if (!nextConsultation || !nextConsultation.date) return null;

        const consultationDate = new Date(nextConsultation.date as string);
        const now = new Date();
        const consultationEndDate = new Date(consultationDate.getTime() + nextConsultation.config.duration.value * 60000); // duration in minutes

        if (now >= consultationDate && now <= consultationEndDate) {
            // Консультация сейчас идет
            return (
                <FRCC px={2} mb={'5px'} py={1} rounded={3} wrap cls={'fs-5 fw-bold'} maxW={420}
                      color={plt.text.primary40}
                      bg={plt.colors.secondary.lighter}>
                    Консультация уже идет
                    <Button
                        className="h-min px-2 pt-6px ms-3"
                        style={{
                            backgroundColor: plt.colors.secondary.main,
                            color: '#fff',
                            fontWeight: 'bold',
                        }}
                        size={'small'}
                        onClick={handleJoinConference}
                    >
                        В конференцию
                    </Button>
                </FRCC>
            );
        }

        const diffMs = consultationDate.getTime() - now.getTime();
        if (diffMs <= 0) return null;

        const diffMinutesTotal = Math.floor(diffMs / (1000 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);

        if (diffMinutesTotal < 10) {
            if (nextConsultation.conference && nextConsultation.conference.name) {
                return (
                    <FR g={2} mb={1} sx={{justifyContent: {xs: 'center', sm: 'start', md: 'start'}}}>
                        <div className={'px-3 py-2 rounded-3 fw-bold'} style={{
                            background: plt.colors.secondary.lighter,
                            color: plt.text.primary40,
                            display: 'inline-block'
                        }}>
                            <FRSC g={2}>
                                <span style={{lineHeight: '1rem'}}>Скоро начинается!</span>
                                <Button
                                    className="h-min px-2 pt-6px"
                                    style={{
                                        backgroundColor: plt.colors.secondary.main,
                                        color: '#fff',
                                        fontWeight: 'bold',
                                    }}
                                    size={'small'}
                                    onClick={handleJoinConference}
                                >
                                    В конференцию
                                </Button>
                            </FRSC>
                        </div>
                    </FR>
                );
            } else {
                return (
                    <FR mb={1} sx={{justifyContent: {xs: 'center', sm: 'start', md: 'start'}}}>
                        <div className={'px-3 py-2 rounded-3 fw-bold'} style={{
                            background: plt.colors.secondary.lighter,
                            color: plt.text.primary40,
                            display: 'inline-block'
                        }}>
                            Начнется через {diffMinutesTotal} минут
                        </div>
                    </FR>
                );
            }
        }

        if (diffDays === 0 && diffHours === 0 && diffMinutesTotal >= 10) {
            return (
                <FR mb={1} sx={{justifyContent: {xs: 'center', sm: 'start', md: 'start'}}}>
                    <div className={'px-3 py-2 rounded-3 fw-bold'} style={{
                        background: plt.colors.secondary.lighter,
                        color: plt.text.primary40,
                        display: 'inline-block'
                    }}>
                        Начнется через {diffMinutesTotal} минут
                    </div>
                </FR>
            );
        } else if (diffDays === 0 && diffHours > 0) {
            return (
                <FR mb={1} sx={{justifyContent: {xs: 'center', sm: 'start', md: 'start'}}}>
                    <div className={'px-3 py-2 rounded-3 fw-bold'} style={{
                        background: plt.colors.secondary.lighter,
                        color: plt.text.primary40,
                        display: 'inline-block'
                    }}>
                        Следующая консультация через {diffHours} час{diffHours > 1 ? 'ов' : ''}
                    </div>
                </FR>
            );
        } else if (diffDays === 1) {
            return (
                <FR mb={1} sx={{justifyContent: {xs: 'center', sm: 'start', md: 'start'}}}>
                    <div className={'px-3 py-2 rounded-3 fw-bold'} style={{
                        background: plt.colors.secondary.lighter,
                        color: plt.text.primary40,
                        display: 'inline-block'
                    }}>
                        Следующая консультация завтра
                    </div>
                </FR>
            );
        } else if (diffDays > 1) {
            return (
                <FR mb={1} sx={{justifyContent: {xs: 'center', sm: 'start', md: 'start'}}}>
                    <div className={'px-3 py-2 rounded-3 fw-bold'} style={{
                        background: plt.colors.secondary.lighter,
                        color: plt.text.primary40,
                        display: 'inline-block'
                    }}>
                        Следующая консультация через {diffDays} дней
                    </div>
                </FR>
            );
        }

        return null;
    }, [nextConsultation, navigate, theme]);

    return (
        <>
            {nextConsultationTime && nextConsultationTime}
        </>
    );
};

export default NearestConsultationWidget;
